import { Box } from '@deckee/deck-hand';
import React, { FC } from 'react';

export interface MetricBoxProps {
  label: string;
  value: string;
}

const MetricBox: FC<MetricBoxProps> = ({ label, value }) => (
  <Box
    border="0.5px solid"
    borderColor="lightergrey"
    borderRadius="8px"
    bg="white"
    minHeight="56px"
    px={2}
    py={2}
    display="flex"
    flexDirection="column"
    justifyContent="center"
  >
    <Box fontSize={1} fontWeight={700} color="black" lineHeight="1.2">
      {value}
    </Box>
    <Box fontSize="13px" color="darkergrey" lineHeight="1.2" mt="2px">
      {label}
    </Box>
  </Box>
);

export default MetricBox;
